import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, PieChart, Pie, Cell, LineChart, Line, ResponsiveContainer } from 'recharts';
import { DownloadIcon, FilterIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { reportDistrictData, reportMutationData, reportTaxData } from '../data/sampleData';
const COLORS = ['#006A4E', '#C9A84C', '#3B82F6', '#EF4444', '#8B5CF6'];
export function ReportsPage() {
  const {
    language,
    t
  } = useLanguage();
  return <div className="space-y-6" data-id="element-2116">
      <div className="flex justify-between items-center" data-id="element-2117">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-2118">{t('navReports')}</h1>
        <div className="flex space-x-2" data-id="element-2119">
          <button className="px-3 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-colors text-sm flex items-center" data-id="element-2120">
            <FilterIcon className="w-4 h-4 mr-2" data-id="element-2121" /> Filter
          </button>
          <button className="px-3 py-2 bg-[#006A4E] text-white rounded-lg font-medium hover:bg-[#004D3A] transition-colors text-sm flex items-center shadow-sm" data-id="element-2122">
            <DownloadIcon className="w-4 h-4 mr-2" data-id="element-2123" /> Export
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-2124">
        {/* District Distribution */}
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200" data-id="element-2125">
          <h2 className="text-lg font-bold text-gray-900 mb-6" data-id="element-2126">
            District-wise Plot Distribution
          </h2>
          <div className="h-64" data-id="element-2127">
            <ResponsiveContainer width="100%" height="100%" data-id="element-2128">
              <BarChart data={reportDistrictData} data-id="element-2129">
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E5E7EB" data-id="element-2130" />
                <XAxis dataKey={language === 'bn' ? 'nameBn' : 'name'} axisLine={false} tickLine={false} data-id="element-2131" />
                <YAxis axisLine={false} tickLine={false} data-id="element-2132" />
                <Tooltip cursor={{
                fill: '#F3F4F6'
              }} contentStyle={{
                borderRadius: '8px',
                border: 'none',
                boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)'
              }} data-id="element-2133" />
                <Bar dataKey="plots" fill="#006A4E" radius={[4, 4, 0, 0]} data-id="element-2134" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Mutation Status */}
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200" data-id="element-2135">
          <h2 className="text-lg font-bold text-gray-900 mb-6" data-id="element-2136">
            Mutation Status Overview
          </h2>
          <div className="h-64" data-id="element-2137">
            <ResponsiveContainer width="100%" height="100%" data-id="element-2138">
              <PieChart data-id="element-2139">
                <Pie data={reportMutationData} cx="50%" cy="50%" innerRadius={60} outerRadius={80} paddingAngle={5} dataKey="value" nameKey={language === 'bn' ? 'nameBn' : 'name'} data-id="element-2140">
                  {reportMutationData.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} data-id="element-2141" />)}
                </Pie>
                <Tooltip contentStyle={{
                borderRadius: '8px',
                border: 'none',
                boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)'
              }} data-id="element-2142" />
                <Legend verticalAlign="bottom" height={36} data-id="element-2143" />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Tax Collection Trend */}
        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200 lg:col-span-2" data-id="element-2144">
          <h2 className="text-lg font-bold text-gray-900 mb-6" data-id="element-2145">
            Tax Collection Trend (2026)
          </h2>
          <div className="h-72" data-id="element-2146">
            <ResponsiveContainer width="100%" height="100%" data-id="element-2147">
              <LineChart data={reportTaxData} data-id="element-2148">
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E5E7EB" data-id="element-2149" />
                <XAxis dataKey="month" axisLine={false} tickLine={false} data-id="element-2150" />
                <YAxis axisLine={false} tickLine={false} data-id="element-2151" />
                <Tooltip contentStyle={{
                borderRadius: '8px',
                border: 'none',
                boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)'
              }} data-id="element-2152" />
                <Legend data-id="element-2153" />
                <Line type="monotone" dataKey="paid" name="Paid Tax" stroke="#006A4E" strokeWidth={3} dot={{
                r: 4
              }} activeDot={{
                r: 6
              }} data-id="element-2154" />
                <Line type="monotone" dataKey="due" name="Due Tax" stroke="#EF4444" strokeWidth={3} dot={{
                r: 4
              }} activeDot={{
                r: 6
              }} data-id="element-2155" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>;
}